import { render, staticRenderFns } from "./Block_rec.vue?vue&type=template&id=953343ee&"
import script from "./Block_rec.vue?vue&type=script&lang=js&"
export * from "./Block_rec.vue?vue&type=script&lang=js&"
import style0 from "./Block_rec.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports